import React, { useState } from 'react';
import { LockKeyhole, Mail } from 'lucide-react';
import './LoginPage.css';
import { useAuth } from '../../context/AuthContext';
import { showToast } from '../../utils/feedback';

const Login = () => {
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loggingIn, setLoggingIn] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoggingIn(true);
      await login(formData.email.trim(), formData.password);
      showToast({ icon: 'success', title: 'Welcome back!' });
    } catch (error) {
      showToast({ icon: 'error', title: error?.message || 'Invalid credentials.' });
    } finally {
      setLoggingIn(false);
    }
  };

  return (
    <div className="login-container" style={{ backgroundImage: "url('/assets/login-bg.jpg')" }}>
      <div className="login-overlay" />

      <div className="login-content-wrapper">
        <div className="login-form-box">
          <div className="card-body p-4 p-md-5">
            <img src="/assets/alpho-logo.png" style={{ width: 150 }} alt="Alpho ID Solution" className="mb-3" />
            <div className="login-kicker">Secure access</div>
            <h2 className="h4 fw-bold mb-2">School Admin Login</h2>
            <p className="text-muted mb-4">Sign in to continue managing student records for your school.</p>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <div className="input-group login-input-group">
                  <span className="input-group-text"><Mail size={16} /></span>
                  <input
                    type="email"
                    className="form-control"
                    value={formData.email}
                    onChange={(e) => setFormData((prev) => ({ ...prev, email: e.target.value }))}
                    required
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label">Password</label>
                <div className="input-group login-input-group">
                  <span className="input-group-text"><LockKeyhole size={16} /></span>
                  <input
                    type="password"
                    className="form-control"
                    value={formData.password}
                    onChange={(e) => setFormData((prev) => ({ ...prev, password: e.target.value }))}
                    required
                  />
                </div>
              </div>

              <button type="submit" className="btn btn-primary w-100 login-btn" disabled={loggingIn}>
                {loggingIn ? (
                  <span className="d-inline-flex align-items-center gap-2">
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    Signing in...
                  </span>
                ) : (
                  'Login'
                )}
              </button>

              <small className="d-block text-left mt-3 text-muted">
                Application developed by <a style={{fontWeight: 'bold', textDecoration:'none'}} href="https://its.net.in" title='ITS - Info Twist Solutions' target="_blank" rel="noopener noreferrer">ITS</a>
              </small>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
